import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Home_Category_Banner.css";
import Cetegory_Banner from "./Cetegory_Banner/Cetegory_Banner";
import Sidebar_list from "./Sidebar_list/Sidebar_list";
import Feature_section from "./Feature_section/Feature_section";

function Home_Category_Banner({category}) {
  return (
    <div className="hcb-main">
      <div className="custom_container">
        <Row className="">
          <Col xxl={2} lg={3} md={4} sm={12}>
            <Sidebar_list category={category}/>
          </Col>

          {/* Right Section */}
          <Col xxl={10} lg={9} md={8} sm={12}>
            <Cetegory_Banner />

            <Feature_section />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Home_Category_Banner;
